import { render, staticRenderFns } from "./TransactionsTable.vue?vue&type=template&id=7be457b6"
import script from "./TransactionsTable.vue?vue&type=script&lang=js"
export * from "./TransactionsTable.vue?vue&type=script&lang=js"
import style0 from "./TransactionsTable.vue?vue&type=style&index=0&id=7be457b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports